import React from 'react'
import { useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useLocation } from 'react-router-dom';
import "../styles/Header.css";

function Header() {
	const location = useLocation();
	const path = location.pathname;
	const navRef = useRef();
	


	const showNavbar = () => {
		navRef.current.classList.toggle(
			"responsive_nav"
		);
	};

	return (
		<header>
			<div className='header-primal-logo'>
			<h3>PRIMAL GRID</h3>
			<p>An Online Interactive Demo</p>
			</div>
			
			<nav ref={navRef} className='header-nav'>
				<a href="/home" className={path === '/home' | path === '/' ? 'active' : ''}>Home</a>
				
				<a href="/about" className={path  === '/about' ? 'active' : ''} >About</a>
				<a href="/primal" className={path  === '/primal' ? 'active' : ''} >PRIMAL Demo</a>
				<a href="/contact" className={path  === '/contact' ? 'active' : ''}  >Contact</a>
				{/* <a href="/faq" className={path  === '/faq' ? 'active' : ''}  >FAQ</a> */}

				<button
					className="nav-btn nav-close-btn"
					onClick={showNavbar}>
					<FaTimes />
				</button>
			</nav>
			<button
				className="nav-btn"
				onClick={showNavbar}>
				<FaBars />
			</button>
		</header>
	);
}

export default Header;